// Detalle de crecimiento del Inicio del admin (reorden admin 24-oct-2026). Antes era la pantalla «Analíticas Globales»
// (1 vista en 90 días): sus dos paneles reales viven aquí, plegados; se abren con #crecimiento (los KPI del Inicio
// y la ruta vieja /dashboard/admin/analytics apuntan ahí). Su «Estado del Sistema» (Elasticsearch/Firebase en verde,
// cableado en duro) se eliminó: nada de eso se usa ya.
import { useEffect, useRef, useState, type FC } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronDown, TrendingUp } from 'lucide-react';
import BusinessGrowthPanel from '../../features/analytics/components/BusinessGrowthPanel';
import AdminBusinessMetrics from '../../features/analytics/components/AdminBusinessMetrics';

const DetalleCrecimiento: FC = () => {
  const { hash } = useLocation();
  const [abierto, setAbierto] = useState(hash === '#crecimiento');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hash !== '#crecimiento') return;
    setAbierto(true);
    const t = window.setTimeout(() => ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
    return () => window.clearTimeout(t);
  }, [hash]);

  return (
    <div ref={ref} id="crecimiento" className="scroll-mt-20" data-testid="detalle-crecimiento">
      <button
        type="button"
        onClick={() => setAbierto((v) => !v)}
        aria-expanded={abierto}
        data-testid="detalle-crecimiento-toggle"
        className="w-full flex items-center justify-between rounded-lg border border-line bg-surface px-4 py-3 text-left hover:border-accent transition-colors"
      >
        <span className="flex items-center text-sm font-semibold text-content">
          <TrendingUp className="h-4 w-4 mr-2 text-accent" /> Crecimiento y totales de la plataforma (detalle)
        </span>
        <ChevronDown className={`h-4 w-4 text-content-3 transition-transform ${abierto ? 'rotate-180' : ''}`} />
      </button>
      {abierto && (
        <div className="mt-4 space-y-6 animate-fade-in-up">
          <BusinessGrowthPanel />
          <AdminBusinessMetrics />
        </div>
      )}
    </div>
  );
};

export default DetalleCrecimiento;
